import React from 'react';
import { Box } from '@mui/material';
import MyReservationsPage from './MyReservationsPage';

/**
 * Page autonome pour les réservations locataire
 * Vue directe sans wrapper complexe
 */
const RenterReservationsStandalonePage = () => {
  return (
    <Box sx={{ 
      minHeight: 'calc(100vh - 230px)',
      position: 'relative',
      paddingBottom: '20px',
      display: 'flex', 
      flexDirection: 'column'
    }}>
      <Box sx={{ flexGrow: 1 }}>
        <MyReservationsPage key="renter-reservations" embedded={false} />
      </Box>
    </Box>
  );
};

export default RenterReservationsStandalonePage;
